import { useEffect, useMemo } from "react";
import { __ } from "@wordpress/i18n";
import { css } from "@/utils/css";
import { useRoute } from "@/hooks/use-route";
import { $ } from "@/utils/constants";

import Antimanual from "./antimanual";
import KnowledgeBase from "./knowledge-base";
import AutoPosting from "./auto-posting";
import Chatbot from "./chatbot";
import BulkRewrite from "./bulk-rewrite";
import Docs from "./docs";
import BBPress from "./bbpress";

const pages = [
    {
        slug: "antimanual",
        label: __("API Configuration", "antimanual"),
        element: <Antimanual />,
    },
    {
        slug: "atml-knowledge-base",
        label: __("Knowledge Base", "antimanual"),
        element: <KnowledgeBase />,
    },
    {
        slug: "atml-auto-posting",
        label: __("Auto Posting", "antimanual"),
        element: <AutoPosting />,
    },
    {
        slug: "atml-chatbot",
        label: __("Chatbot", "antimanual"),
        element: <Chatbot />,
    },
    {
        slug: "atml-bulk-rewrite",
        label: __("Bulk Rewrite", "antimanual"),
        element: <BulkRewrite />,
    },
    {
        slug: "atml-docs",
        label: __("Generate Docs", "antimanual"),
        element: <Docs />,
    },
    {
        slug: "atml-bbpress",
        label: __("Forum Automation", "antimanual"),
        element: <BBPress />,
    },
];

export default function App() {
    const { query, updateQuery } = useRoute();

    const activePage = useMemo(() => {
        const page = pages.find((item) => item.slug === query.page);
        return page || pages[0];
    }, [query.page]);

    const changePage = (page: (typeof pages)[0]) => {
        const title = document.title;
        const newTitle = title.replace(activePage.label, page.label);
        updateQuery({ page: page.slug });
        document.title = newTitle;
    };

    useEffect(() => {
        const $menuLinks = $("#toplevel_page_antimanual ul li a");

        const handleMenuClick = (e: JQuery.ClickEvent): void => {
            const $link = $(e.currentTarget);
            const href = $link.attr("href");

            if (!href) return;

            const urlParams = new URLSearchParams(href.split("?")[1]);
            const pageSlug = urlParams.get("page");
            const validPage = pages.find((item) => item.slug === pageSlug);

            if (validPage) {
                e.preventDefault();
                changePage(validPage);
            }
        };

        $menuLinks.on("click", handleMenuClick);

        return () => {
            $menuLinks.off("click", handleMenuClick);
        };
    }, [activePage.slug]);

    useEffect(() => {
        const $menuLinks = $("#toplevel_page_antimanual ul li a");

        $menuLinks.removeClass("current");
        $menuLinks.removeAttr("aria-current");
        $menuLinks.closest("li").removeClass("current");

        $menuLinks.each((_, link) => {
            const $link = $(link);
            const href = $link.attr("href");

            if (href) {
                const urlParams = new URLSearchParams(href.split("?")[1]);
                const pageSlug = urlParams.get("page");

                if (pageSlug === activePage.slug) {
                    $link.addClass("current");
                    $link.attr("aria-current", "page");
                    $link.closest("li").addClass("current");
                }
            }
        });
    }, [activePage.slug]);

    return (
        <div className={css("atml-react-app-admin")}>
            <div className={css("atml-navbar")}>
                <div className={css("plugin-name")}>{__("Antimanual", "antimanual")}</div>
                <div className={css("navbar-tab-wrapper")}>
                    {pages.map((page) => (
                        <a
                            key={page.slug}
                            href={`?page=${page.slug}`}
                            className={css("nav-item", activePage.slug === page.slug ? "nav-item-active" : "")}
                            onClick={(e) => {
                                e.preventDefault();
                                changePage(page);
                            }}
                        >
                            {page.label}
                        </a>
                    ))}
                </div>
            </div>
            <div id={activePage.slug} className={css("tab-content antimanual-tab-pane")}>
                {activePage.element}
            </div>
        </div>
    );
}
